<template>
  <v-list flat color="accent">
    <div v-for="item in items" :key="item.title">
      <div v-show="showItem(item.condition)">
        <!-- parents -->
        <v-list-item
          link
          :class="{ active: isActiveLink(item.internalLink) }"
          @click="openLink(item.externalLink, item.internalLink)"
        >
          <v-list-item-icon
            :class="{ active: isActiveLink(item.internalLink) }"
          >
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>

          <v-list-item-icon
            v-if="getChildren(item.items)"
            :class="{ active: isActiveLink(item.internalLink) }"
          >
            <v-icon v-if="isActiveParent(item.internalLink)"
              >mdi-chevron-down</v-icon
            >
            <v-icon v-else>mdi-chevron-right</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <!-- children -->
        <div v-if="isActiveParent(item.internalLink)">
          <div v-for="child in getChildren(item.items)" :key="child.title">
            <v-list-item
              v-if="showItem(child.condition)"
              style="background: #f8f8f8"
              link
              :to="child.internalLink"
              :href="child.externalLink"
              :class="{ active: isActiveLink(child.internalLink) }"
            >
              <v-list-item-icon
                :class="{ active: isActiveLink(child.internalLink) }"
              >
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="child.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>
      </div>
    </div>
  </v-list>
</template>

<style scoped>
.v-list {
  min-width: 15vw;
  height: 100%;
}

.v-list-item__icon {
  color: rgb(109, 109, 109);
  align-self: unset;
}

.active {
  color: #0065bd !important;
}

.v-list-item__icon .active {
  color: #0065bd !important;
}

.theme--light.v-icon {
  color: unset;
}
</style>

<script>
import { baseUrl } from "@/constants";
import { useUserServiceInject } from "@/context";

export default {
  setup() {
    const { loggedIn, username, isStaff, isTutor } = useUserServiceInject();
    const toHomePage = () => {
      window.location.href = baseUrl;
    };

    const toAboutPage = () => {
      window.location.href = baseUrl + "about/";
    };

    return {
      toHomePage,
      toAboutPage,
      loggedIn,
      username,
      isStaff,
      isTutor,
    };
  },
  methods: {
    showItem(cond) {
      if (cond == "N") {
        return true;
      } else if (cond == "L") {
        return this.loggedIn == true;
      } else if (cond == "LNT") {
        return this.loggedIn && !this.isTutor;
      } else if (cond == "T") {
        return this.isTutor;
      } else if (cond == "S") {
        return this.isStaff;
      } else if (cond == "NL") {
        return !this.loggedIn;
      } else {
        return false;
      }
    },
    isActiveLink(path) {
      if (path && this.$route.meta.navItem) {
        return path === this.$route.meta.navItem;
      } else {
        return false;
      }
    },
    isActiveParent(path) {
      if (path && this.$route.meta.navItem) {
        return this.$route.meta.navItem.startsWith(path);
      } else {
        return false;
      }
    },
    getChildren(children) {
      if (children.length) {
        const showChildren = [];
        children.forEach((child) => {
          if (this.showItem(child.condition)) {
            showChildren.push(child);
          }
        });
        if (showChildren.length <= 0) return null;
        return showChildren;
      } else {
        return null;
      }
    },
    openLink(external, internal) {
      if (external) {
        window.open(external, "_blank").focus();
      } else if (internal) {
        this.$router.push(internal);
      }
    },
  },
  data: () => ({
    model: 2,
    items: [
      {
        icon: "mdi-home-outline",
        items: [],
        title: "Startseite",
        internalLink: "/",
        condition: "N",
      },
      /* {
        icon: "mdi-file-outline",
        title: "Übungstool",
        internalLink: "/exercises",
        condition: "N",
        items: [
          {
            title: "Hinzufügen",
            icon: "mdi-plus",
            internalLink: "/exercises/new",
            condition: "S",
          },
          {
            title: "Meine Übungen",
            icon: "mdi-format-list-bulleted",
            internalLink: "/exercises/my-exercises",
            condition: "S",
          },
          {
            title: "Korrigieren",
            icon: "mdi-clipboard-check-outline",
            internalLink: "/exercises/correct",
            condition: "S",
          },
        ],
      }, */
      {
        icon: "mdi-account-group-outline",
        items: [
          {
            title: "Meine Tutorien",
            icon: "mdi-format-list-bulleted",
            internalLink: "/tutorials/profile/",
            condition: "T",
          },
          {
            title: "Matching",
            icon: "mdi-puzzle-outline",
            internalLink: "/tutorials/matching",
            condition: "T",
          },
          {
            title: "Ereignisse",
            icon: "mdi-calendar-range-outline",
            internalLink: "/tutorials/event",
            condition: "T",
          },
          {
            title: "Verwaltung",
            icon: "mdi-cog-outline",
            internalLink: "/tutorials/admin",
            condition: "S",
          },
          {
            title: "Statistiken",
            icon: "mdi-chart-donut",
            internalLink: "/tutorials/admin/statistics",
            condition: "S",
          },
          {
            title: "Mein Tutorium",
            icon: "mdi-format-list-bulleted",
            internalLink: "/tutorials/my-tutorial",
            condition: "LNT",
          },
          {
            title: "Mein Tutorium (dev view)",
            icon: "mdi-format-list-bulleted",
            internalLink: "/tutorials/my-tutorial",
            condition: "S",
          },
        ],
        title: "Tutorien",
        internalLink: "/tutorials",
        condition: "N",
      },
      {
        icon: "mdi-chart-timeline",
        items: [],
        title: "Scheduler",
        externalLink: "https://scheduling.tum.sexy/",
        condition: "N",
      },
      {
        icon: "mdi-book-open-page-variant-outline",
        items: [],
        title: "Paging",
        externalLink: "https://paging.tum.sexy/",
        condition: "N",
      },
      {
        icon: "mdi-login-variant",
        items: [],
        title: "Login",
        internalLink: "/login",
        condition: "NL",
      },
      {
        icon: "mdi-logout-variant",
        items: [],
        title: "Logout",
        internalLink: "/logout",
        condition: "L",
      },
      {
        icon: "mdi-information-outline",
        items: [],
        title: "About",
        internalLink: "/about",
        condition: "N",
      },
    ],
  }),
};
</script>
